import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col place-items-center w-full h-screen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-grow" }, null, -1)
const _hoisted_3 = { class: "flex flex-col place-items-center text-center" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" The external website might be down. ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-grow" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-grow" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_gv_image = _resolveComponent("gv-image")!
  const _component_gv_type = _resolveComponent("gv-type")!
  const _component_mobile = _resolveComponent("mobile")!

  return (_openBlock(), _createBlock(_component_mobile, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_gv_image, {
            src: require('@/domains/app/assets/NotFound.svg')
          }, null, 8, ["src"]),
          _createVNode(_component_gv_type, {
            class: "pt-2",
            text: "Oops!",
            variant: "display-xl"
          }),
          _createVNode(_component_gv_type, { scheme: "secondary" }, {
            default: _withCtx(() => [
              _createTextVNode(" We couldn't reach " + _toDisplayString(_ctx.serviceName ?? "the requested page") + ". ", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_gv_type, { scheme: "secondary" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_gv_type, {
            class: "pt-2",
            text: "Please try again later.",
            scheme: "tertiary"
          })
        ]),
        _hoisted_5,
        _hoisted_6
      ])
    ]),
    _: 1
  }))
}